import { Star, Users, ShieldCheck, Activity } from "lucide-react";
import { CLINIC } from "../../data/content";

export default function TrustBar() {
  return (
    <div className="border-y border-black/5 bg-white">
      <div className="container-wide py-4 flex flex-wrap items-center gap-x-8 gap-y-3 text-xs md:text-sm text-brand-ink2">
        <span className="flex items-center gap-2">
          <Star className="text-brand-amber fill-brand-amber" size={14} /> {CLINIC.rating}★ Google Rating
        </span>
        <span className="flex items-center gap-2"><Users size={14} /> {CLINIC.reviewsCount} Patient Reviews</span>
        <span className="flex items-center gap-2"><ShieldCheck size={14} /> Personalised Treatment Plans</span>
        <span className="flex items-center gap-2"><Activity size={14} /> Sports & Neuro Rehabilitation</span>
      </div>
    </div>
  );
}
